import { FunctionComponent, ReactNode } from 'react'

import { SearchQueryResult } from '../hooks/useQueries'

import ComponentError from '../components/display/ComponentError'
import FilterBar from './filters/desktop/FilterBar'
import ScrollTop from '../components/utils/ScrollTop'

import {
  Outerwrapper,
  FilterBarWrapper,
  ResultsArea,
  MapContainer,
  StickyBar,
} from '../components/layout/ItemGridWithMap/Desktop'

interface DesktopSearchViewProps {
  filters: GQL_SearchFilters
  defaults: SearchQueryResult['data']['search']['defaults']
  minPrice: number
  maxPrice: number
  resultsComponent: ReactNode
  mapComponent: ReactNode
  searchTypeToggleComponent: ReactNode
}

const DesktopSearchView: FunctionComponent<DesktopSearchViewProps> = ({
  filters,
  defaults,
  minPrice,
  maxPrice,
  resultsComponent,
  mapComponent,
  searchTypeToggleComponent,
}) => {
  const hasFiltersBar = !(filters.type === 'stories' && !filters.state)

  return (
    <Outerwrapper className="js-global-loader-container">
      <ScrollTop />
      <StickyBar>
        {hasFiltersBar && (
          <FilterBarWrapper>
            {searchTypeToggleComponent}
            <FilterBar
              filters={filters}
              defaults={defaults}
              minPrice={minPrice}
              maxPrice={maxPrice}
            />
          </FilterBarWrapper>
        )}
        <MapContainer>
          <ComponentError name="search-map">{mapComponent}</ComponentError>
        </MapContainer>
      </StickyBar>
      <ResultsArea>
        <ComponentError name="search-results">
          {resultsComponent}
        </ComponentError>
      </ResultsArea>
    </Outerwrapper>
  )
}

export default DesktopSearchView
